import React from 'react';

const ForthcomingItemLoading = () => (
  <div className="development-item col-md-4 col-sm-6 col-lg-4">
    <div className="shadow">
      <div className="img-responsive" />
      <div className="container-fluid forthcoming-container">
        <div className="loading" style={{ height: 22, width: 200, marginTop: 15 }} />
        <div className="loading" style={{ height: 15, width: 120, marginTop: 8 }} />
        <div className="loading" style={{ height: 10, width: 220, marginTop: 8 }} />
        <div className="loading" style={{ height: 10, width: 120, marginTop: 5 }} />
        <div className="available-from" style={{ marginBottom: 10 }}>
          <div className="loading" style={{ height: 15, width: 150, marginTop: 0 }} />
        </div>
      </div>
    </div>
  </div>
);

export default ForthcomingItemLoading;
